var exports = {
  "iE": "xaee3c4fa--d7bd1f--wrapper",
  "lc": "xaee3c4fa--d7bd1f--wrapper-mobile",
  "OD": "xaee3c4fa--d7bd1f--decor-image",
  "wx": "xaee3c4fa--d7bd1f--header",
  "dB": "xaee3c4fa--d7bd1f--header-tablet",
  "ZC": "xaee3c4fa--d7bd1f--fields-row",
  "Ky": "xaee3c4fa--d7bd1f--block-wrapper",
  "vj": "xaee3c4fa--d7bd1f--lead-in",
};

module.exports = exports;
